export default {
  emptyTable: "Brak danych",
  info: "Pozycje od _START_ do _END_ z _TOTAL_ łącznie",
  infoEmpty: "Pozycje 0 z 0 dostępnych",
  infoFiltered: "(filtrowanie spośród _MAX_ dostępnych pozycji)",
  infoThousands: " ",
  lengthMenu: "Pokaż _MENU_ pozycji",
  loadingRecords: "Wczytywanie...",
  processing: "Przetwarzanie...",
  search: "Szukaj:",
  zeroRecords: "Nie znaleziono pasujących pozycji",
  paginate: {
    first: "Pierwsza",
    last: "Ostatnia",
    next: "Następna",
    previous: "Poprzednia"
  },
  aria: {
    sortAscending: ": aktywuj, by posortować kolumnę rosnąco",
    sortDescending: ": aktywuj, by posortować kolumnę malejąco"
  }
}
